import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./pages/callback.component').then((m) => m.CallbackComponent),
  },
  {
    // After Authentik end-session redirects back here, just show Home.
    path: 'auth/logout/callback',
    loadComponent: () =>
      import('./pages/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/signup.component').then((m) => m.SignupComponent),
  },
  {
    path: 'signup/verify',
    loadComponent: () =>
      import('./pages/signup-verify.component').then((m) => m.SignupVerifyComponent),
  },
  {
    path: 'protected',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/protected.component').then((m) => m.ProtectedComponent),
  },
  // IAM docs — reachable from the header (public reference material).
  {
    path: 'architecture',
    loadComponent: () =>
      import('./pages/architecture.component').then((m) => m.ArchitectureComponent),
  },
  {
    path: 'flow',
    loadComponent: () => import('./pages/flow.component').then((m) => m.FlowComponent),
  },
  {
    path: 'integrate',
    loadComponent: () =>
      import('./pages/integrate.component').then((m) => m.IntegrateComponent),
  },
  {
    path: 'register-client',
    loadComponent: () =>
      import('./pages/register-client.component').then((m) => m.RegisterClientComponent),
  },
  { path: '**', redirectTo: '' },
];
